module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAIBJREFUOE+t0lEKABEQBuDxwCW8KOeQa8jplLO5g/Iwmy2ym9XQepSv+ccMQ0SEg8N+h1LKaY6U0n0/rZhzBq31PvTeQwgBhBAdtwTLivWRtfaBp/CrnxFvQWMMxBiBcw7kqCOqjZKgc65Xar9DgqUUUErtj2OM9tbLcVBW93hXL8bhbdf/2W+fAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/logOut.png
// module id = r3Zk
// module chunks = 12